import i18n from "i18next";
import { getItem, setItem } from "@/lib/storage";

export const ENGINE_LANGS = ["es", "en"];
export const B2C_LANGS = ["es"];
export const LOCALE_BY_LANG = { es: "es-ES", en: "en-GB" };

export const PUBLIC_LANG_BY_PREFIX = [["/en", "en"]];

// "/en" exacto o "/en/...": startsWith("/en") a secas casaria "/enlaces".
export function publicLangOf(pathname) {
  if (typeof pathname !== "string") return null;
  const hit = PUBLIC_LANG_BY_PREFIX.find(([prefix]) => pathname === prefix || pathname.startsWith(`${prefix}/`));
  return hit ? hit[1] : null;
}

export const isEngineRoute = (pathname) =>
  typeof pathname === "string" && /^\/app\/engine(\/|$)/.test(pathname);

// En una ruta del Engine el menu espera a saber si es miembro y a tener su catalogo e idioma: hasta entonces saldria
// en espanol. Si /engine/me falla tampoco se sabe si es miembro: la pagina ofrece reintentar. Fuera del Engine nunca espera.
export const engineShellPending = ({ pathname, engineLoading, member, shellReady, languageSettled, engineError }) =>
  isEngineRoute(pathname) && (Boolean(engineLoading) || Boolean(engineError) || (Boolean(member) && !(shellReady && languageSettled)));

export const supportedLang = (lang) => (ENGINE_LANGS.includes(lang) ? lang : null);

export function resolveLanguage({ member, user, orgLanguage, navigatorLanguages } = {}) {
  if (!member) return "es";
  const chosen = user?.language_chosen_at ? supportedLang(user.language) : null;
  if (chosen) return chosen;
  const fromOrg = supportedLang(orgLanguage);
  if (fromOrg) return fromOrg;
  for (const tag of navigatorLanguages || []) {
    const fromNavigator = supportedLang(String(tag).split("-")[0].toLowerCase());
    if (fromNavigator) return fromNavigator;
  }
  return "es";
}

export const STORED_LANG_KEY = "qc_lang";

export const getStoredLang = () => supportedLang(getItem(STORED_LANG_KEY));

export function setStoredLang(lang) {
  if (!supportedLang(lang)) return false;
  setItem(STORED_LANG_KEY, lang);
  return true;
}

export const currentLang = () => i18n.language || "es";
export const currentLocale = () => LOCALE_BY_LANG[currentLang()] || LOCALE_BY_LANG.es;

// El menu compartido con el B2C solo sigue el idioma activo en el bloque del Engine y en sus rutas.
export const engineLabelLang = (engineMode, pathname, lang) => (engineMode && isEngineRoute(pathname) ? lang : "es");
